<img src="/assets/images/login/dialog/close.svg" alt="Cerrar" class="close-icon" (click)="closeDialog()">
<div class="title" [innerHTML]="'pendingVerificationDialog_Data7' | i18n"></div>
<div class="description" [innerHTML]="'pendingVerificationDialog_Data2' | i18n: translationModes.INSERT_VALUE : email"></div>
<div class="warning" [innerHTML]="'pendingVerificationDialog_Data5' | i18n"></div>
<button [innerHTML]="'pendingVerificationDialog_Data6' | i18n" (click)="closeDialog(responses.CONTACT)" [routerLink]="getRouterLink('Contact')"></button>


